import { gql } from "@apollo/client";

export const LOGIN_MUTATION = gql`
  mutation Login($Mobile_Number: String!, $password: String!) {
    login(Mobile_Number: $Mobile_Number, password: $password) {
      id
      First_Name
      Last_Name
      Mobile_Number
      Role
      Payment_Status
      isAdmin
    }
  }
`;

export const ADD_MEMBER_MUTATION = gql`
  mutation AddMember(
    $First_Name: String!
    $Last_Name: String!
    $Mobile_Number: String!
    $DOB: String!
    $City: String!
    $District: String!
    $State: String!
    $Pincode: String!
    $ID_Proof_Type: String
    $ID_Proof_Number: String
    $Pan_Card: String
    $Pan_Number: String
    $agreed: Boolean
  ) {
    addMember(
      First_Name: $First_Name
      Last_Name: $Last_Name
      Mobile_Number: $Mobile_Number
      DOB: $DOB
      City: $City
      District: $District
      State: $State
      Pincode: $Pincode
      ID_Proof_Type: $ID_Proof_Type
      ID_Proof_Number: $ID_Proof_Number
      Pan_Card: $Pan_Card
      Pan_Number: $Pan_Number
      agreed: $agreed
    ) {
      id
    }
  }
`;

export const ADMIN_ADD_MEMBER_MUTATION = gql`
  mutation AddMember(
    $First_Name: String!
    $Last_Name: String!
    $Mobile_Number: String!
    $DOB: String!
    $City: String!
    $District: String!
    $State: String!
    $Pincode: String!
    $Email: String
    $Occupation: String
    $Address: String
    $Marital_Status: String
    $ID_Proof_Type: String
    $ID_Proof_Number: String
    $Pan_Card: String
    $Pan_Number: String
    $Star: String
    $Raasi: String
    $Kootram: String
    $Kuladeivam: String
    $Family_Details: String
    $Payment_Status: String
    $Payment_Id: String
    $Payment_Method: String
    $Payment_Date: String
  ) {
    addMember(
      First_Name: $First_Name
      Last_Name: $Last_Name
      Mobile_Number: $Mobile_Number
      DOB: $DOB
      City: $City
      District: $District
      State: $State
      Pincode: $Pincode
      Email: $Email
      Occupation: $Occupation
      Address: $Address
      Marital_Status: $Marital_Status
      ID_Proof_Type: $ID_Proof_Type
      ID_Proof_Number: $ID_Proof_Number
      Pan_Card: $Pan_Card
      Pan_Number: $Pan_Number
      Star: $Star
      Raasi: $Raasi
      Kootram: $Kootram
      Kuladeivam: $Kuladeivam
      Family_Details: $Family_Details
      Payment_Status: $Payment_Status
      Payment_Id: $Payment_Id
      Payment_Method: $Payment_Method
      Payment_Date: $Payment_Date
    ) {
      id
      First_Name
      Last_Name
      Mobile_Number
      DOB
      City
      District
      State
      Pincode
      Email
      Role
      Occupation
      Address
      isDeleted
      Marital_Status
      ID_Card
      ID_Proof_Type
      ID_Proof_Number
      Pan_Card
      Pan_Number
      Payment_Id
      Payment_Status
      Payment_Method
      Payment_Date
      Family_Details
      Star
      Raasi
      Kootram
      Kuladeivam
    }
  }
`;

export const EDIT_MEMBER_MUTATION = gql`
  mutation EditMember(
    $id: String!
    $First_Name: String!
    $Last_Name: String!
    $Mobile_Number: String!
    $DOB: String!
    $City: String!
    $District: String!
    $State: String!
    $Pincode: String!
    $Email: String
    $Occupation: String
    $Address: String
    $Marital_Status: String
    $ID_Proof_Type: String
    $ID_Proof_Number: String
    $Pan_Card: String
    $Pan_Number: String
    $Star: String
    $Raasi: String
    $Kootram: String
    $Kuladeivam: String
    $Family_Details: String
    $ID_Card: String
    $Role: String
    $Payment_Id: String
    $Payment_Date: String
    $Payment_Status: String
    $Payment_Method: String
  ) {
    editMember(
      id: $id
      First_Name: $First_Name
      Last_Name: $Last_Name
      Mobile_Number: $Mobile_Number
      DOB: $DOB
      City: $City
      District: $District
      State: $State
      Pincode: $Pincode
      Email: $Email
      Occupation: $Occupation
      Address: $Address
      Marital_Status: $Marital_Status
      ID_Proof_Type: $ID_Proof_Type
      ID_Proof_Number: $ID_Proof_Number
      Pan_Card: $Pan_Card
      Pan_Number: $Pan_Number
      Star: $Star
      Raasi: $Raasi
      Kootram: $Kootram
      Kuladeivam: $Kuladeivam
      Family_Details: $Family_Details
      ID_Card: $ID_Card
      Payment_Id: $Payment_Id
      Role: $Role
      Payment_Date: $Payment_Date
      Payment_Status: $Payment_Status
      Payment_Method: $Payment_Method
    ) {
      id
      First_Name
      Last_Name
      Mobile_Number
      DOB
      City
      District
      State
      Pincode
      Email
      Role
      Occupation
      Address
      Marital_Status
      ID_Proof_Type
      ID_Proof_Number
      Pan_Card
      Pan_Number
      Star
      Raasi
      Kootram
      Kuladeivam
      Family_Details
      Payment_Date
      Payment_Id
      Payment_Status
      Payment_Method
    }
  }
`;

export const DELETE_MUTATION = gql`
  mutation DeleteMember($id: String!) {
    deleteMember(id: $id) 
  }
`;

export const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPassword($Id: String!, $New_Password: String!) {
    changePassword(id: $Id, newPassword: $New_Password)
  }
`;

export const FORGOT_PASSWORD_MUTATION = gql`
  mutation ResetPassword($Mobile: String!, $New_Password: String!) {
    forgetpassword(mobile: $Mobile, newPassword: $New_Password)
  }
`;
